<template>
  <div class="navbar-wrapper">
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-contain="1"
      class="w-nav navbar"
    >
      <div class="w-container navbar-container">
        <router-link
          :to="{ name: 'Home' }"
          class="w-nav-brand logo-container"
        >
          <h1 class="text-logo">
            ROARINGSKY
          </h1>
        </router-link>
        <nav
          role="navigation"
          class="w-nav-menu nav-menu"
        >
          <router-link
            :to="{ name: 'Home' }"
            class="w-nav-link nav-link"
          >
            Home
          </router-link>
          <router-link
            :to="{ name: 'OurTeam' }"
            class="w-nav-link nav-link"
          >
            Team
          </router-link>
          <!-- <div
            data-delay="0"
            class="w-dropdown nav-dropdown"
          >
            <div class="w-dropdown-toggle nav-link">
              <div>About us</div>
              <div class="w-icon-dropdown-toggle" />
            </div>
            <nav class="w-dropdown-list dropdown-list">
              <router-link
                :to="{ name: 'AboutUs' }"
                class="w-dropdown-link dropdown-link"
              >
                Our story
              </router-link>
              <router-link
                :to="{ name: 'OurTeam' }"
                class="w-dropdown-link dropdown-link"
              >
                Our team
              </router-link>
              <router-link
                to="/404"
                class="w-dropdown-link dropdown-link"
              >
                404 page
              </router-link>
            </nav>
          </div> -->
          <!-- <router-link
            :to="{ name: 'Services' }"
            class="w-nav-link nav-link"
          >
            Services
          </router-link> -->
          <router-link
            :to="{ name: 'Portfolio' }"
            class="w-nav-link nav-link"
          >
            Clients
          </router-link>
          <!-- <router-link
            :to="{ name: 'Blog' }"
            class="w-nav-link nav-link"
          >
            Blog
          </router-link> -->
          <router-link
            :to="{ name: 'Contact' }"
            class="w-nav-link nav-link"
          >
            Contact
          </router-link>
        </nav>
        <div class="w-nav-button menu-button">
          <div class="w-icon-nav-menu" />
        </div>
      </div>
    </div>
    <div
      data-ix="navbar-bg"
      class="navbar-bg"
    />
  </div>
</template>

<script>
export default {}
</script>
